// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._benefits_ovsxs_1 {
  --pa-benefits-gap-inner: var(--pa-benefits-gap, var(--perxis-auto-gap-vertical-green-inner));
}
._benefits_ovsxs_1.perxis-auto-1_18_1-benefits {
  padding: var(--pa-benefits-gap-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
